module.exports = __webpack_public_path__ + "static/media/card_m2b.baf4e355.jpg";